import React, { useEffect, useState } from "react";
// @material-ui/core components
// material-ui icons
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import RichTextEditor from "react-rte";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import MailOutline from "@material-ui/icons/MailOutline";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance"; 
import Edit from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);

export default function AddMethod() {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState("Default Template");
  const [emailBody, setEmailBody] = useState(RichTextEditor.createEmptyValue());
  //const [statusSms, setStatusSms] = useState(false);
  const [rows, setRows] = useState([{ id: 1, label: "", text: "" }]);

  const [formValue, setFormValue] = useState({
    name: "",
    Currency: "",
    rate: "",
    minAmount: "",
    maxAmount: "",
    percentageCharge: "",
    withdrawInstraction: "",
  });

  const handleSimple = (e) => {
    setFormValue({
      ...formValue,
      [e.target.id]: e.target.value,
    });
  };
  const handleEditorChange = (newValue) => {
    setEmailBody(newValue);
    newValue.toString("html");
  };

  const handleCellChange = (event, id, field) => {
    const updatedRows = [...rows];
    const updatedRow = updatedRows.find((row) => row.id === id);
    updatedRow[field] = event.target.value;
    setRows(updatedRows);
  };

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/notification`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(users);
        setUsers(res.data.data);
      })

      .catch((err) => {
        console.log(err);
        if(err.response.data.message=="For security reasons, we locked your account.Please login to continue"){
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };

  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      label: "",
      type: 0,
    };
    setRows([...rows, newRow]);
  };
  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      const payload = {
        name: formValue.name,
        currency: formValue.currency,
        rate: formValue.rate,
        minAmount: formValue.minAmount,
        maxAmount: formValue.maxAmount,
        fixedCharge: formValue.fixedCharge,
        percentageCharge: formValue.percentageCharge,
        withdrawInstraction: formValue.withdrawInstraction,
        userDate: rows,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      console.log("API response:", response.data);
      // Handle the response data here
      setIsEditing(true);
    } catch (error) {
      console.error("API error:", error);
      if(error?.response?.data?.message=="For security reasons, we locked your account.Please login to continue"){
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      }
      // Handle any errors that occurred during the API call
    }
  };

  return (
    <>
      <GridContainer>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>New Withdrawal Method</h4>
          </CardHeader>
          <CardBody>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="Name"
                id="name"
                handleChange={handleSimple}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "text",
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="Currency"
                id="currency"
                handleChange={handleSimple}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "number",
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="rate"
                id="rate"
                handleChange={handleSimple}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "number",
                }}
              />
            </GridItem>
            <GridItem xs={6}>
              <Card>
                <CardHeader color="rose" icon>
                  <h4 className={classes.cardIconTitle}>Range</h4>
                </CardHeader>
                <CardBody>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Minimum Amount"
                      id="minAmount"
                      handleChange={handleSimple}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Maximum Amount"
                      id="maxAmount"
                      handleChange={handleSimple}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                      }}
                    />
                  </GridItem>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={6}>
              <Card>
                <CardHeader color="rose" icon>
                  <h4 className={classes.cardIconTitle}>Charge</h4>
                </CardHeader>
                <CardBody>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Fixed Charge"
                      id="fixedCharge"
                      handleChange={handleSimple}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Percentage Charge"
                      id="percentageCharge"
                      handleChange={handleSimple}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="rate"
                      id="rate"
                      handleChange={handleSimple}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                      }}
                    />
                  </GridItem>
                </CardBody>
              </Card>
            </GridItem>
          </CardBody>
        </Card>
        <GridItem xs={12} style={{ marginBottom: "15px" }}>
          <div onClick={handleClick}>
            {isEditing ? (
              <CustomInput
                value={text}
                onChange={handleChange}
                onBlur={handleBlur}
                autoFocus
                fullWidth
              />
            ) : (
              <div>
                {text} <Edit />
              </div>
            )}
          </div>
        </GridItem>
        <GridItem xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead
                style={{ backgroundColor: "#3C37FF", color: "#fffff" }}
              >
                <TableRow>
                  <TableCell style={{ color: "#ffffff" }}>Label</TableCell>
                  <TableCell style={{ color: "#ffffff" }}>Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <TextField
                        value={row.label}
                        onChange={(event) =>
                          handleCellChange(event, row.id, "label")
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.type}
                        onChange={(event) =>
                          handleCellChange(event, row.id, "type")
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <Button onClick={handleAddRow}>WIthdraw Instructions</Button>
      <GridContainer style={{ marginTop: "35px" }}>
        <GridItem xs={5} component={Paper} justify="space-between">
          <GridContainer container>
            <GridItem
              xs={12}
              style={{
                height: "40px",
                background: "#3C37FF",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              WIthdraw Instructions
            </GridItem>
            <GridItem xs={12}>
              <RichTextEditor
                value={emailBody}
                onChange={handleEditorChange}
                style={{ height: "300px" }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem>
          <Button
            color="#3C37FF"
            style={{ float: "right" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </GridItem>
      </GridContainer>
    </>
  );
}
